import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

const aboutSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '重生萝莉岛',
    url: 'https://chongshengluolidao.com',
    description: '以神秘岛屿为背景的重生冒险题材内容平台，汇聚攻略指南、剧情解析、角色图鉴等丰富内容。',
    email: 'contact@chongshengluolidao.com',
    foundingDate: '2024',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于重生萝莉岛',
    description: '了解重生萝莉岛的品牌故事、团队理念和联系方式。',
    url: 'https://chongshengluolidao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '重生萝莉岛',
      url: 'https://chongshengluolidao.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://chongshengluolidao.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://chongshengluolidao.com/about',
      },
    ],
  },
];

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 | 重生萝莉岛"
        description="了解重生萝莉岛的品牌故事、团队理念和联系方式。重生萝莉岛是以神秘岛屿为背景的重生冒险题材内容平台。"
        keywords="重生萝莉岛,关于我们,品牌介绍,联系方式,萌系重生故事"
        canonicalUrl="https://chongshengluolidao.com/about"
        jsonLd={aboutSchemas}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />
        <BrandIntro />
        <Reputation />
        <ContactSection />
      </main>
    </>
  );
}